import {TEAL_500, TEAL_600} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Link = styled.div`
  color: ${TEAL_600};
  &:hover {
    color: ${TEAL_500};
  }
  cursor: pointer;
`;

export const Text = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

export const AliasOrTagList = styled.div`
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
